import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom'
import $ from 'jquery';
import logo from '../../img/logo.PNG'
import search from '../../img/Search_Icon.png'
import cart from '../../img/cart-icon.png'
import notification from '../../img/notification_icon.png'
import toggle from '../../img/toggle.png'
import './Navbar.css'

const Navbar = () => {
    const [show, setShow] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const navControl = () => {
        $('.nav-menu-res').slideToggle()
    }
    const closeNavbar = () => {
        $(".nav-menu-res").slideUp()
    }
    const controlNavbar = () => {
        if (typeof window !== 'undefined') {
            if (window.scrollY > lastScrollY) { // if scroll down hide the navbar
                if (window.scrollY < 10) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            } else { // if scroll up show the navbar
                setShow(true);
            }

            // remember current page location to use in the next move
            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', controlNavbar);

            // cleanup function
            return () => {
                window.removeEventListener('scroll', controlNavbar);
            };
        }
    }, [lastScrollY]);

    return (
        <div>
            <nav className={`navbar ${(!show) ? 'hide' : 'show'}`}>
                <div className='nav-container'>
                    <div className='nav-icon'>
                        <img src={search} alt="search" />
                        <img src={cart} alt="cart" />
                    </div>
                    <div className='nav-logo'>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className="nav-notification">
                        <img src={notification} alt="notification" />
                    </div>
                </div>
                <ul className="nav-menu">
                    <li><NavLink end className="nav-link" to="/">الرئيسية</NavLink></li>
                    <li><NavLink className="nav-link" to="/charger">الشواحن</NavLink></li>
                    <li><NavLink className="nav-link" to="/headPhone">السماعات</NavLink></li>
                    <li><NavLink className="nav-link" to="/watche">الساعات</NavLink></li>
                    <li><NavLink className="nav-link" to="/smart">اكسسوارات ذكية</NavLink></li>
                    <li><NavLink className="nav-link" to="/offers">اقوي العروض</NavLink></li>
                </ul>
            </nav>
            <nav className={`responsive-navbar ${(!show) ? 'hide' : 'show'}`}>
                <div className='nav-container-res'>
                    <div className='nav-icon'>
                        <img src={search} alt="search" />
                        <img src={cart} alt="cart" />
                    </div>
                    <div className='nav-logo'>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className="nav-toggle" onClick={navControl}>
                        <img src={toggle} alt="toggle" />
                    </div>
                </div>
                <ul className="nav-menu-res">
                    <li><NavLink end className="nav-link-res" onClick={closeNavbar} to="/">الرئيسية</NavLink></li>
                    <li><NavLink className="nav-link-res" onClick={closeNavbar} to="/charger">الشواحن</NavLink></li>
                    <li><NavLink className="nav-link-res" onClick={closeNavbar} to="/headPhone">السماعات</NavLink></li>
                    <li><NavLink className="nav-link-res" onClick={closeNavbar} to="/watche">الساعات</NavLink></li>
                    <li><NavLink className="nav-link-res" onClick={closeNavbar} to="/smart">اكسسوارات ذكية</NavLink></li>
                    <li><NavLink className="nav-link-res" onClick={closeNavbar} to="/offers">اقوي العروض</NavLink></li>
                </ul>
            </nav>
        </div>
    );
}

export default Navbar;